/* eslint-disable max-lines-per-function, max-lines */
import { EventBus, Events, store } from "jiffy-store";
import { api } from "jiffy-api";
import { sendDataLayer, sendDataLayerOnLinkClickEvent } from "jiffy-analytics";
import { isElementVisible } from "common/utils/ui/visibility";
import { activateIub } from "common/utils/ui/iub-consent-utils";
import idleCallback, { timings } from "common/utils/ui/idle_callback";
import initColorsSlider from "components/jiffy/product-colors-slider/product-colors-slider";
import initLeftInfo from "components/jiffy/product-details-info-left/product-details-info-left";
import initContinueShoppingModal from "components/jiffy/continue-shopping-modal/continue-shopping-modal";
import initLightBox from "components/jiffy/product-lightbox/product-lightbox";
import initColorPicker, {
  listenForColorSelect
} from "components/jiffy/product-color-picker/product-color-picker";
import { isMobileBrowser } from "common/utils/browser";
import initRelatedProducts from "components/jiffy/product-related-products/product-related-products";
import initJiffyFirstDeliveryDate from "components/jiffy/product-details-delivery-date/product-details-delivery-date";
import initProductDetailsImageCarousel from "components/jiffy/product-details-image-carousel/product-details-image-carousel";
import initReviewSummary from "components/jiffy/review-summary/review-summary";
import initQuantityForm from "components/jiffy/product-details-quantity-form/product-details-quantity-form";
import initDesktopGridToggle from "components/jiffy/product-desktop-grid-toggle/product-desktop-grid-toggle";
import initProductGrid from "components/jiffy/product-grid/product-grid";
import productPage from "components/jiffy/product-details-quantity-form/product-page";
import initReviews from "components/jiffy/reviews-list/reviews-list";
import setFieldsOnGrids from "components/jiffy/product-details-quantity-form/set-fields-on-grids";
import initValidationModal from "components/jiffy/cart-validation-modal/cart-validation-modal";
import initProductDetailsBulkMobile from "components/jiffy/product-details-bulk-mobile/product-details-bulk-mobile";
import initProductDetailsDtfSheet from "components/jiffy/product-details-dtf-sheet/product-details-dtf-sheet";
import initProductDetailsFeatures from "components/jiffy/product-details-features/product-details-features";
import initProductDetailsHeader from "components/jiffy/product-details-header/product-details-header";
import initProductDetailsTitle from "components/jiffy/product-details-title/product-details-title";
import initJiffyServicesPreview from "components/jiffy/jiffy-services-preview/jiffy-services-preview";
import initProductDetailsSummary from "components/jiffy/product-details-summary/product-details-summary";
import initProductDetailsGangSheetDiscount from "components/jiffy/product-details-gang-sheet-discount/product-details-gang-sheet-discount";
import initOtherTransferUpsells from "components/jiffy/upsell-other-transfers/upsell-other-transfers";
import initProductDetailsPrint from "components/jiffy/vue-product-details-print/vue-product-details-print";
import initPdpMadeBanner from "components/jiffy/pdp-made-banner/pdp-made-banner";
import initPdpExperienceSwitcherV2 from "components/jiffy/pdp-experience-switcher-v2/pdp-experience-switcher-v2";
import initPdpExperienceWarning from "components/jiffy/pdp-experience-warning/pdp-experience-warning";
import initUploadMadeButton from "components/jiffy/product-details/product-details-upload-button/product-details-upload-button";
import initProductDeliveryTimeleft from "components/jiffy/product-delivery-timeleft/product-delivery-timeleft";
import initBackButton from "./product-details-back/product-details-back";
import initInventory from "./inventory";
import setPdpBadges from "./set-pdp-badges";
import loadPrices from "./load-prices";
import "common/customer/redirect_to_help";
import "components/jiffy/grid-validation-modal/grid-validation-modal";
import "components/jiffy/product-comments/product-comments";
import "components/jiffy/bulk-discount-toggle-rows/bulk-discount-toggle-rows";
import "components/jiffy/product-details-special-header/product-details-special-header";
import "components/jiffy/product-details-discontinued/product-details-discontinued";
import "components/jiffy/product-details-subtitle/product-details-subtitle";
import "components/jiffy/product-details-brand/product-details-brand";
import "components/jiffy/product-details-user-feedback/product-details-user-feedback";
import "components/jiffy/product-details-badges/product-details-badges";
import "components/jiffy/product-details-badges-carousel/product-details-badges-carousel";
import "components/jiffy/product-details-info-right/product-details-info-right";
import "components/jiffy/product-details-mask-disclaimer/product-details-mask-disclaimer";
import "components/jiffy/product-details-mask-manufacturer-description/product-details-mask-manufacturer-description";
import "components/jiffy/product-details-description/product-details-description";
import "components/jiffy/product-details-measurements/product-details-measurements";
import "components/jiffy/product-details-savings/product-details-savings";
import "components/jiffy/product-details-tabbed-info/product-details-tabbed-info";
import "components/jiffy/product-details-video/product-details-video";
import "components/jiffy/product-notes/product-notes";
import "components/jiffy/product-shipping-notes/product-shipping-notes";
import "components/jiffy/after-blanks-added-modal/after-blanks-added-modal";
import "components/jiffy/facemask-details-bulk-discount/facemask-details-bulk-discount";
import "components/jiffy/product-details-bulk-discount/product-details-bulk-discount.scss";
import "components/jiffy/product-details/product-details-suggested-searches/product-details-suggested-searches";
import "components/jiffy/product-details/product-details-page-header/product-details-page-header";
import "components/jiffy/final-sale-badge/final-sale-badge";
import "components/jiffy/brands/storefront-pdp/storefront-pdp";
import "components/jiffy/gangsheet-builder-additional-details/gangsheet-builder-additional-details";
import "./product-details.scss";

const hideLink = document.querySelector("#product-details__hide-details");
const bulkUiElements = Array.from(
  [
    document.querySelector(".product-details-info-right__bulk_buyers_button"),
    document.querySelector(".product-details__bulk_buyers_button"),
    document.querySelector(".js-product-details-info-left__bulk-discount-toggle"),
    ...document.querySelectorAll(".product-details-bulk-discount")
  ].filter(Boolean)
);
const caseUiElements = Array.from(document.querySelectorAll(".product-details-savings__case"));
const msrpPricesElements = Array.from(
  document.querySelectorAll(".js-product-details-savings-amounts")
);

const initEvents = () => {
  listenForColorSelect(event => {
    const link = event.target.closest(".product-color-picker__item");
    if (link) {
      sendDataLayerOnLinkClickEvent(
        event,
        {
          genericEvent: true,
          eventCategory: "Product page color picker",
          event: "Color click",
          eventLabel: null,
          eventValue: 1
        },
        link
      );
    }
  });

  EventBus.on(Events.PRODUCT_COLOR_SELECTED, () => {
    sendDataLayer({
      genericEvent: true,
      eventCategory: "Product page color picker",
      event: "Color click",
      eventLabel: null,
      eventValue: 1
    });
  });

  EventBus.on(Events.COLOR_PICKER_OPENED, () => {
    sendDataLayer({
      genericEvent: true,
      eventCategory: "Product page color picker",
      event: "Open",
      eventLabel: null,
      eventValue: 1
    });
  });

  EventBus.on(Events.COLOR_PICKER_CLOSED, () => {
    sendDataLayer({
      genericEvent: true,
      eventCategory: "Product page color picker",
      event: "Close",
      eventLabel: null,
      eventValue: 1
    });
  });

  EventBus.on(Events.COLOR_PICKER_SCROLLED, () => {
    const { App } = window;

    const datePiecePlaces = document.querySelectorAll(".js-composition-delivery-date");

    const visibleDatePiecePlaces = Array.from(datePiecePlaces).filter(element =>
      isElementVisible(element)
    );

    let compositionIds = Array.from(visibleDatePiecePlaces).map(
      element => element.dataset.compositionId
    );

    if (compositionIds.length > 0) {
      // ensure we send each composition once
      compositionIds = compositionIds.filter(id => !window.compositionIdsSent.includes(id));

      if (compositionIds.length > 0) {
        App.pdpColorPickerDatesChannel.send({ composition_ids: compositionIds });
      }
    }
  });
};

const highlightColorPickerItem = () => {
  const $activeColorName = document.getElementById("active-color-name");
  if (!$activeColorName) return;

  const highlightedItem = document.querySelector(
    `[data-color='${$activeColorName.value}'].product-color-picker__item`
  );
  highlightedItem.classList.add("product-color-picker__item--active");
};

const initChildrenComponents = () => {
  initJiffyFirstDeliveryDate();
  initContinueShoppingModal();
  initLeftInfo();
  initLightBox();
  initBackButton();
  initUploadMadeButton().init();
  initRelatedProducts();
  initProductDetailsImageCarousel();
  initColorsSlider();
  initInventory();
  setPdpBadges();
  setFieldsOnGrids();
  initReviews();
  initReviewSummary();
  initValidationModal();
  initProductDetailsSummary();
  initProductDetailsFeatures();
  initOtherTransferUpsells();
  initProductDetailsPrint();
  initProductDetailsTitle();
  initProductDetailsGangSheetDiscount();
};

const bindEvents = () => {
  EventBus.on(Events.ADD_TO_CART, ({ target }) => {
    let numberOfItemsInCart = 0;
    $.each(target.items, (variantId, qty) => {
      numberOfItemsInCart += qty;
    });

    let eventLabel = numberOfItemsInCart;
    if (numberOfItemsInCart === 0) {
      eventLabel = "NullAddToCart";
    }

    sendDataLayer({
      genericEvent: true,
      eventCategory: "AddToCart",
      event: target.eventAction,
      eventValue: eventLabel
    });
  });

  store.ui.changed((_, { data }) => {
    if (!data.shopBy) return;

    msrpPricesElements.forEach(el => el.classList.add(el.dataset.highlightClass));

    setTimeout(() => {
      msrpPricesElements.forEach(el => el.classList.remove(el.dataset.highlightClass));
    }, 1000);

    if (data.shopBy === "case") {
      bulkUiElements.forEach(el => el.classList.add("hidden"));
      caseUiElements.forEach(el => el.classList.remove("hidden"));
      hideLink.click();
    } else {
      bulkUiElements.forEach(el => el.classList.remove("hidden"));
      caseUiElements.forEach(el => el.classList.add("hidden"));
    }
  });
};

const setCsrfTokens = async () => {
  const csrfTokenSelector = "meta[name='csrf-token']";
  const { content: token } = document.head.querySelector(csrfTokenSelector);

  const $favoriteSignInForm = document.querySelector(".js-product-details-favorite-sign-in-form");
  const $restockNotificationForm = document.querySelector(
    ".js-product-details-notify-on-restock-sign-in-form"
  );
  const $quantityForm = document.querySelector(".js-product-details-quantity-form");
  const $favoriteInput = $favoriteSignInForm?.querySelector('input[name="authenticity_token"]');
  const $quantityInput = $quantityForm?.querySelector('input[name="authenticity_token"]');
  const $restockNotificationInput = $restockNotificationForm?.querySelector(
    'input[name="authenticity_token"]'
  );

  $favoriteInput?.setAttribute("value", token);
  $quantityInput?.setAttribute("value", token);
  $restockNotificationInput?.setAttribute("value", token);
};

const fetchDynamicJavascripts = async () => {
  const productId = $('[name="product_id"]').val();
  const colorName = $('[id="active-color-name"]').val();
  if (!productId || !colorName) return;

  const $productDetails = document.querySelector(".js-product-details");

  const dynamicJavascriptsResponse = await api.product.fetchDynamicJavascripts({
    product_id: productId,
    color_name: colorName,
    experiment_updates: $productDetails.dataset.experimentUpdates,
    experiment_updates_rudderstack: $productDetails.dataset.experimentUpdatesRudderstack
  });

  if (dynamicJavascriptsResponse.scripts) {
    const parser = new DOMParser();
    const scripts = parser.parseFromString(dynamicJavascriptsResponse.scripts, "text/html");

    scripts.querySelectorAll("script").forEach(script => {
      const newScript = document.createElement("script");

      ["async", "dataset", "defer", "id", "onerror", "src", "type", "class"].forEach(attr => {
        if (script[attr]) {
          if (attr === "dataset") {
            Object.entries(script.dataset).forEach(([key, value]) => {
              newScript.dataset[key] = value;
            });
          } else {
            newScript[attr] = script[attr];
          }
        } else if (["onerror", "class"].includes(attr)) {
          const attrValue = script.getAttribute(attr);
          attrValue && newScript.setAttribute(attr, attrValue);
        }
      });

      newScript.textContent = script.text;
      document.body.appendChild(newScript);
    });

    /* eslint-disable no-underscore-dangle */
    activateIub(window._iub);
    /* eslint-enable no-underscore-dangle */
  }
};

// Swap pdp elements from desktop to mobile layout
function applyResponsive() {
  const isDtf = document.querySelector("#product-page-container")?.dataset.isDtf === "true";

  if (isMobileBrowser() || isDtf) {
    return;
  }

  function insertAfter(referenceNode, newNode) {
    if (newNode && referenceNode?.nextSibling) {
      referenceNode?.parentNode?.insertBefore(newNode, referenceNode.nextSibling);
    }
  }

  const productImage = document.querySelector(".js-product-lightbox-wrapper");
  const productColorSlider = document.querySelector(".js-product-colors-slider");
  const deliveryDate = document.querySelector(
    "#js-product-details-delivery-dates-simple-container"
  );
  const quantityFormTitle = document.querySelector(
    ".js-product-details-info-left__quantity-form-title"
  );
  const productDetailsVariantsForm = document.querySelector("#product-details-variants-form");
  const productDetailsVariantsFormFooter = document.querySelector(
    ".js-product-details-variants-form__footer"
  );
  const productDetailsUpsellSection = document.querySelector("#product-details-upsell-section");

  const mobileMedia = window.matchMedia("(min-width: 768px)");

  const desktopHeaderLeft = document.querySelector(".js-product-details-header__left");

  function reflow({ matches }) {
    if (matches) {
      insertAfter(desktopHeaderLeft, productDetailsVariantsFormFooter);
      insertAfter(desktopHeaderLeft, productDetailsUpsellSection);
      insertAfter(desktopHeaderLeft, productDetailsVariantsForm);
      insertAfter(desktopHeaderLeft, quantityFormTitle);
      insertAfter(desktopHeaderLeft, productColorSlider);
      insertAfter(desktopHeaderLeft, deliveryDate);
    } else {
      insertAfter(productImage, productDetailsVariantsFormFooter);
      insertAfter(productImage, productDetailsUpsellSection);
      insertAfter(productImage, productDetailsVariantsForm);
      insertAfter(productImage, quantityFormTitle);
      insertAfter(productImage, deliveryDate);
      insertAfter(productImage, productColorSlider);
    }
  }

  mobileMedia.addEventListener("change", reflow);

  if (!mobileMedia.matches) {
    reflow(mobileMedia);
  }
}

export default () => {
  applyResponsive();
  initEvents();
  initColorPicker();
  setCsrfTokens();

  const $productDetails = document.querySelector(".js-product-details");
  const { itemsInCart } = $productDetails?.dataset || {};
  window.itemsInCart = itemsInCart;

  initChildrenComponents();
  bindEvents();
  highlightColorPickerItem();
  fetchDynamicJavascripts();
  initProductDetailsBulkMobile();
  initProductDetailsHeader();
  initJiffyServicesPreview();
  initProductDetailsDtfSheet();
  initPdpMadeBanner();
  initPdpExperienceSwitcherV2();
  initPdpExperienceWarning();
  initProductDeliveryTimeleft();

  idleCallback(() => {
    initQuantityForm();
    productPage.initLineItems();
    loadPrices();
  }, timings.quantityForm);

  idleCallback(() => {
    initProductGrid();
    initDesktopGridToggle();
  }, timings.productGrid);
};
